import * as React from "react";
import DialogContent from '@material-ui/core/DialogContent';

import environment from '../environment';
import Sprite from "../sprite";
import ContentLibrary from './ContentLibrary/ContentLibrary';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Restore, RestoreCostumeAddStatus } from "../utils/restore";
import I4kDialog from "./components/Dialog/I4kDialog";
import { Button, Typography } from "@material-ui/core";
import UploadCostumeModal from '../containers/UploadCostumeModal';

interface LibraryCostumeProps extends WithTranslation {
    readonly trigger: any;
    readonly sprite: Sprite;
    readonly parent: any;
}

interface LibraryCostumeState {
    open: boolean;
    contentJSON: {
        backgrounds?: Record<string, any>,
        costumes?: Record<string, any>,
    };
}

class LibraryCostumeModal extends React.Component<LibraryCostumeProps, LibraryCostumeState> {
    constructor(props: LibraryCostumeProps) {
        super(props);
        this.state = {open: false, contentJSON: {}};
        fetch(environment.CONTENT_FOLDER + '/it4kids/content.json').then(res => res.json()).then(json => {
            this.setState({
                contentJSON: json
            });
        });
    }

    open = () => {
        this.setState({open: true});
        // this.props.parent.handleCostumeMenuClose();
    };

    close = () => {
        this.setState({open: false});
    };

    select = (name: string, fileURL: string) => {
        Restore.costumeAddStatus = RestoreCostumeAddStatus.COSTUME;
        this.props.sprite.addCostumeUrl(name, fileURL);
        this.close();
    };

    render() {
        const {t} = this.props;
        const {contentJSON} = this.state;

        const relevantContent = this.props.sprite.isStaticBackground ? contentJSON.backgrounds : contentJSON.costumes

        return ([
            React.cloneElement(this.props.trigger, {key: "1", onClick: this.open}),
            (
                <I4kDialog
                key="2"
                title={t('LibraryCostumeModal.title')}
                showModal={this.state.open}
                onClose={this.close}
                onConfirm={this.close}
                showConfirmButton={false}
            >     
                    <DialogContent style={{overflow: 'hidden', height: 'calc(100% - 264px)'}}>
                            <ContentLibrary
                                contentJSON={relevantContent || {}}
                                onMediaSelected={(costumeEntry) => this.select(costumeEntry.name, costumeEntry.data)} />
                            
                            <UploadCostumeModal sprite={this.props.sprite} parent={this}
                                trigger={<Button
                                    style={{ backgroundColor: '#FFAF8D', border: '3px solid rgb(22, 45, 61)', cursor: 'pointer', width: "380px", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                    onClick={() => {
                                        }}>
                                        <Typography>{t('SpriteEditor.UploadCostumeModal.title')}</Typography>
                                    </Button>}
                                    onClose={this.close}
                            />
                    </DialogContent>
                </I4kDialog>
            )
        ]);
    }
}

export default withTranslation()(LibraryCostumeModal);
